<script setup lang="ts">
const { data } = await useAsyncData(
  'activationResource',
  () => $fetch('/intl-api/crm/activation'),
  {
    server: false,
    lazy: true
  }
)

const templatePrices = computed(() => [
  {
    title: 'Setup Fee',
    price: data.value?.data?.price || 0,
    per_message: 'Hanya Sekali Saja',
    setup_fee: true
  },
  {
    title: 'Marketing',
    price: 687,
    per_message: '/ Pesan Promosi'
  },
  {
    title: 'Utility',
    price: 460,
    per_message: '/ Utilitas (Pengingat & Status Kiriman)'
  }
])
</script>

<template>
  <UiContainer class="py-12 flex flex-col gap-6">
    <UiSectionTitle
      class="text-center"
      title="Harga"
      description="Mulai dari Rp0 - Bayar Hanya Jika Kirim Pesan. Tanpa Biaya Bulanan"
    />

    <div
      class="grid gap-3"
      :class="[
        data?.data?.cashback
          ? 'lg:grid-flow-col lg:grid-rows-2'
          : 'lg:grid-cols-3'
      ]"
    >
      <div
        v-for="(item, index) in templatePrices"
        :key="index"
        class="p-4 flex flex-col gap-4 rounded-3xl border border-surface-container-highest bg-surface-container-low"
        :class="{ 'lg:row-span-2': data?.data?.cashback && item.setup_fee }"
      >
        <p class="font-semibold">{{ item.title }}</p>
        <p
          class="text-primary text-2xl font-bold flex items-center gap-x-2 flex-wrap"
        >
          {{ formatNumber(item.price, true) }}
          <span class="text-base font-normal text-on-surface">{{
            item.per_message
          }}</span>
        </p>
        <div
          v-if="data?.data?.cashback && item.setup_fee"
          class="flex items-start gap-4 rounded-3xl bg-surface-container-lowest p-4"
        >
          <div
            class="flex-none rounded-full p-2 bg-primary-container text-primary"
          >
            <Icon name="material-symbols:undo" size="32px" />
          </div>
          <div class="flex-1 flex flex-col gap-1 text-left">
            <p class="text-outline text-xs">🔥 Dapatkan Cashback Kredit</p>
            <p class="text-2xl font-bold text-primary">
              {{ formatNumber(data.data.cashback) }}
            </p>
            <p v-if="data.data.cashback_until_at" class="text-outline text-sm">
              Berlaku hingga
              {{ formatDateLongMonth(data.data.cashback_until_at) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col md:flex-row gap-4 md:justify-center">
      <UiButton
        :to="
          $utm.utmUrl('/register', {
            redirectTo: '/crm/config?meta_setup=1'
          })
        "
        label="Coba ROMS"
      />
      <UiButton
        :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
        label="Hubungi Kami"
        variant="primaryOutline"
      />
    </div>
  </UiContainer>
</template>
